"use client";

import { IUser } from "@/lib/database/schema";
import { User } from "@/models";
import { ReactNode, createContext, useContext, useMemo } from "react";

export const UserContext = createContext<User | null>(null);

export const useUser = ():User | null  => {
  return useContext(UserContext);
}

export function UserProvider({ user, children }: { user: IUser | null, children: ReactNode }) {
  const userInstance = useMemo(() => (user ? new User(user) : null), [user]);

  return (
    <UserContext.Provider value={userInstance}>
      {children}
    </UserContext.Provider>
  );
}
